import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import '@diekeure/dcr-components/dcr-inline-icon-button.js';
import '@diekeure/dcr-components/dcr-text-field.js';

@Component({
  standalone: false,
  selector: 'campus-search-term',
  templateUrl: './search-term.component.html',
  styleUrls: ['./search-term.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchTermComponent implements OnInit {
  @HostBinding('class')
  defaultClasses = ['search-term', 'flex-1', 'mat-form-field-no-hint'];

  @Input() public initialValue = '';
  @Input() public placeholder = 'Zoeken';
  @Input() public autofocus = false;
  @Input() public showMagnifier = false;
  @Input() public showReset = false;
  @Input() public emptyValueOnReset = false;
  @Input() public disabled = false;

  // boolean => internal reference, need array of values
  // string => external reference TODO: figure this out, when required
  @Input() public autoComplete: string | boolean = true;
  @Input() public autoCompleteValues: string[] = [];
  @Input() public emitOnTextChange = false;

  @HostBinding('class.search-term--rounded')
  @Input()
  public rounded: boolean;

  public currentValue: string;

  @Output() public valueChange = new EventEmitter<string>();
  @Output() public valueChangeForAutoComplete = new EventEmitter<string>();

  constructor(@Inject(ChangeDetectorRef) private cd: ChangeDetectorRef) {}

  public ngOnInit() {
    this.currentValue = this.initialValue;
  }

  public onChange() {
    this.valueChange.emit(this.currentValue);
  }

  public getAutoCompleteValues() {
    if (this.currentValue.length < 2 || !this.autoComplete) return;

    this.valueChangeForAutoComplete.emit(this.currentValue);
  }

  public onTextChange() {
    if (this.emitOnTextChange) {
      this.onChange();
    }
  }

  public updateCurrentValue(value: string) {
    this.currentValue = value;

    this.onTextChange();
  }

  public getAutoFocusValue() {
    return this.autofocus ? 'autofocus' : null;
  }

  public reset(emit = true) {
    this.currentValue = this.emptyValueOnReset ? '' : this.initialValue;
    this.cd.markForCheck();

    if (emit) {
      this.valueChange.emit(this.currentValue || '');
    }
  }
}
